import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`

    @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500&display=swap');

    * {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: 'Roboto', sans-serif;
        font-smooth: antialiased;
        -webkit-font-smoothing: antialiased;
        outline: none;
    }

    body, html, #root {
        width: 100%;
        height: 100%;
        overflow-x: hidden;
        overflow-y: hidden;
    }

    button {
        border: none;
        cursor: pointer;
    }

    input {
        outline: none;
        background: transparent;
    }
`;

export default GlobalStyles;
